// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Roboto/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/Roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/Roboto/Roboto-Medium-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/Roboto/Roboto-Condensed-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/Roboto/Roboto-Condensed-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/Roboto/Roboto-Condensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/Roboto/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/fonts/BebasNeue/BebasNeue-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/fonts/BebasNeue/BebasNeue-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("assets/fonts/BebasNeue/BebasNeue-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("assets/fonts/BebasNeue/BebasNeue-Light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Roboto-Black';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
    font-family: 'Roboto-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
    font-family: 'Roboto-Medium-Italic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
    font-family: 'Roboto-Condensed-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
    font-family: 'Roboto-Condensed-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
    font-family: 'Roboto-Condensed-Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@font-face {
    font-family: 'Roboto-Italic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

@font-face {
    font-family: 'Roboto-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
    font-family: 'Roboto-Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

@font-face {
    font-family: 'BebasNeue-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

@font-face {
    font-family: 'BebasNeue-Book';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

@font-face {
    font-family: 'BebasNeue-Thin';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

@font-face {
    font-family: 'BebasNeue-Light';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFWJ0bbck.woff2)
        format('woff2');
}

/* cyrillic */
@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFUZ0bbck.woff2)
        format('woff2');
}

/* greek-ext */
@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFWZ0bbck.woff2)
        format('woff2');
}

/* greek */
@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFVp0bbck.woff2)
        format('woff2');
}

/* vietnamese */
@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFWp0bbck.woff2)
        format('woff2');
}

/* latin-ext */
@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFW50bbck.woff2)
        format('woff2');
}

/* latin */
@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFVZ0b.woff2)
        format('woff2');
}

/* LOADING TRANSITION */

.table-cell-nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.search-filters-box {
    border: 1px solid lightgray;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 0px 0px 0px;
    position: relative;
    margin-right: 5px;
}

.search-filter-buttons {
    display: flex;
    justify-content: flex-end;
    /* padding-bottom: 20px; */
    padding-top: 20px;
}

/* .css-a2j6v-MuiPaper-root {
    box-shadow:
        rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
        rgba(0, 0, 0, 0.14) 0px 2px 2px 0px,
        rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
} */

.paper-box-shadow-specific {
    box-shadow:
        rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
        rgba(0, 0, 0, 0.14) 0px 2px 2px 0px,
        rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;
}

@media screen and (max-width: 635px) {
    .search-filter-buttons {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding-bottom: 20px;
        padding-top: 20px;
    }
    .search-filter-buttons button {
        margin-right: 0px !important;
        margin-bottom: 10px;
    }

    .active-list-item {
        background-color: #d2112b !important;
        color: white !important;
        align-items: center;
        padding-left: 10px;
    }
}

.ctn-preloader {
    align-items: center;
    -webkit-align-items: center;
    display: flex;
    display: -ms-flexbox;
    height: 100%;
    justify-content: center;
    -webkit-justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 999999;
    background: #000000bd;
}

.ctn-preloader .animation-preloader {
    position: absolute;
    z-index: 100;
    text-align: center;
}

.ctn-preloader .animation-preloader .icon {
    display: inline-block;
    position: relative;
}

.ctn-preloader .animation-preloader .txt-loading {
    -webkit-user-select: none;
            user-select: none;
}

.ctn-preloader .animation-preloader .txt-loading .letters-loading:before {
    animation: letters-loading 4s infinite;
    color: #d2112b;
    content: attr(data-text-preloader);
    left: 0;
    opacity: 0;
    top: 0;
    line-height: 30px;
    position: absolute;
}

.ctn-preloader .animation-preloader .txt-loading .letters-loading {
    font-family: 'Roboto-Regular';
    letter-spacing: 12px;
    display: inline-block;
    color: #d2112c;
    position: relative;
    font-size: 50px;
    line-height: 30px;
}

.ctn-preloader
    .animation-preloader
    .txt-loading
    .letters-loading:nth-child(2):before {
    animation-delay: 0.2s;
}

.ctn-preloader
    .animation-preloader
    .txt-loading
    .letters-loading:nth-child(3):before {
    animation-delay: 0.4s;
}

.ctn-preloader
    .animation-preloader
    .txt-loading
    .letters-loading:nth-child(4):before {
    animation-delay: 0.6s;
}

.ctn-preloader
    .animation-preloader
    .txt-loading
    .letters-loading:nth-child(5):before {
    animation-delay: 0.8s;
}

.ctn-preloader
    .animation-preloader
    .txt-loading
    .letters-loading:nth-child(6):before {
    animation-delay: 1s;
}

.ctn-preloader
    .animation-preloader
    .txt-loading
    .letters-loading:nth-child(7):before {
    animation-delay: 1.2s;
}

.ctn-preloader
    .animation-preloader
    .txt-loading
    .letters-loading:nth-child(8):before {
    animation-delay: 1.4s;
}

.loaded .animation-preloader {
    opacity: 0;
    transition: 0.3s ease-out;
}

@keyframes spinner {
    to {
        transform: rotateZ(360deg);
    }
}

@keyframes letters-loading {
    0%,
    75%,
    100% {
        opacity: 0;
        transform: rotateY(-90deg);
    }

    25%,
    50% {
        opacity: 1;
        transform: rotateY(0deg);
    }
}

@media screen and (max-width: 500px) {
    .ctn-preloader .animation-preloader .txt-loading .letters-loading {
        font-size: 40px;
        letter-spacing: 10px;
    }

    .active-list-item {
        background-color: #d2112b !important;
        color: white !important;
        align-items: center;
        padding-left: 10px;
    }
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin: 0px !important;
}

.Roboto-Black {
    font-family: 'Roboto-Black' !important;
}

.Roboto-Bold {
    font-family: 'Roboto-Bold' !important;
}

.Roboto-Condensed-Bold {
    font-family: 'Roboto-Condensed-Bold' !important;
}

.Roboto-Condensed-Medium {
    font-family: 'Roboto-Condensed-Medium' !important;
}

.Roboto-Condensed-Regular {
    font-family: 'Roboto-Condensed-Regular' !important;
}

.Roboto-Italic {
    font-family: 'Roboto-Italic' !important;
}

.Roboto-Medium {
    font-family: 'Roboto-Medium' !important;
}

.Roboto-Regular {
    font-family: 'Roboto-Regular' !important;
}

.Roboto-Medium-Italic {
    font-family: 'Roboto-Medium-Italic' !important;
}

.BebasNeue-Light {
    font-family: 'BebasNeue-Book' !important;
}

.BebasNeue {
    font-family: 'BebasNeue-Bold' !important;
}

.side-bar-scroll {
    height: 100%;
    overflow: auto;
  }
.side-bar-scroll::-webkit-scrollbar {
    display: none !important;
}
.side-bar-scroll::-webkit-scrollbar-track {
    background: #d2112c;
    width: 0px;
}
.side-bar-scroll::-webkit-scrollbar-thumb {
    background: #d2112c;
    border-radius: 5px !important;
    cursor: pointer;
}

.body::-webkit-scrollbar {
    width: 7px;
}

body::-webkit-scrollbar-track {
    background: #d2112b;
}

body::-webkit-scrollbar-thumb {
    background: #d2112b;
    border-radius: 0;
}

*::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    border-radius: 100;
}

*::-webkit-scrollbar-track {
    background: white;
}

*::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 100;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.padding-0 {
    padding: 0px;
}

.padding-5 {
    padding: 5px;
}

.padding-10 {
    padding: 10px;
}

.padding-20 {
    padding: 20px;
}

.selected-row {
    border-top: 1px solid red;
    border-bottom: 1px solid red;
}

.unselected-row {
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
}

td {
    border-bottom: none !important;
}

.text_feild_small {
    height: 36px !important;
}

.disabled-bg {
    background-color: #efefef !important;
}

.ps__rail-y {
    display: none !important;
}

.border-bottom-black {
    border-bottom: 1px solid #3e3e3e;
}

/* Material Autocomplete */

.MuiAutocomplete-tag {
    background: #fff;
    color: black;
    border-radius: 5px;
    font-family: Roboto-Medium;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    background: transparent;
    color: rgb(0, 0, 0);
}

.css-ue4sux-MuiPickersToolbar-root-MuiDatePickerToolbar-root {
    background-color: #d2112b !important;
    color: #d2112b !important;
}

.css-7bgu36-MuiButtonBase-root-MuiPickersDay-root.Mui-selected {
    background-color: #d2112b !important;
}
.css-7bgu36-MuiButtonBase-root-MuiPickersDay-root.Mui-selected:hover {
    background-color: #d2112b !important;
}

.css-1azxcoc-MuiButtonBase-root-MuiButton-root {
    color: #d2112b !important;
}

.MuiDatePickerToolbar-title {
    color: white !important;
}

.css-1b0xoj9-MuiPickersYear-yearButton.Mui-selected {
    background-color: #d2112b !important;
}

.mobile-container-input:focus + .mobile-container {
    border: 1px solid #d2112b !important;
}

.mobile-container:hover {
    border: 1px solid #d2112b !important;
}
.breadcrumb_time {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

#panel1a-header {
    background-color: #d2112b;
    color: #fff;
}

#panel1a-header > div.MuiAccordionSummary-content,
.MuiAccordionSummary-root {
    min-height: 30px !important;
    max-height: 54px !important;
}

@media screen and (max-width: 425px) {
    .table-scrollbar {
        height: max-content !important;
    }
    .breadcrumb_time {
        display: flex;
        align-items: center !important;
        justify-content: flex-start !important;
    }
    .css-k3ndhj {
        margin-left: 0px;
        width: 100%;
    }
    .active-list-item {
        background-color: #d2112b !important;
        color: white !important;
        align-items: center;
        padding-left: 10px;
    }
    .list-item {
        background-color: #d2112b !important;
        color: white !important;
        align-items: center;
        padding-left: 10px;
    }
}

@media screen and (max-width: 360px) {
    .active-list-item {
        background-color: #d2112b !important;
        color: white !important;
        align-items: center;
        padding-right: 10px;
    }
}

.static-col-width {
    width: 200px !important;
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.width-33 {
    width: 33px !important;
    max-width: 33px !important;
}

.css-g60yx6-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    background: #fff !important;
}

.css-e0n9jt-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {
    background: #fff !important;
}

.css-1pj14c4-MuiInputBase-root-MuiOutlinedInput-root {
    background: #fff !important;
}

.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #d2112b !important;
}

.css-1x7p6i5-MuiInputBase-input-MuiOutlinedInput-input:focus
    + .MuiOutlinedInput-notchedOutline {
    border-color: #d2112b !important;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #d2112b !important;
}

.css-1h582ii-MuiPickersToolbar-root-MuiTimePickerToolbar-root,
.css-9140k-MuiTypography-root-MuiPickersToolbarText-root,
.css-ihhycx-MuiTimePickerToolbar-amPmSelection .MuiTimePickerToolbar-ampmLabel,
.css-mm61pc-MuiTypography-root-MuiPickersToolbarText-root-MuiTimePickerToolbar-separator,
.css-1w4nrh4-MuiClockPointer-thumb,
.css-ff5riy-MuiClock-pin,
.css-1egoljz-MuiClockPointer-root,
.css-338pcd-MuiClockPointer-root,
.css-uhmbur-MuiClockPointer-thumb {
    background-color: #d2112b !important;
    border-color: #d2112b !important;
    color: #fff !important;
}

.css-rixs2p {
    background-color: #d2112b !important;
    color: #d2112b !important;
}

/* mobile date time picker style */
.css-s9q20a-MuiPickersToolbar-root-MuiDateTimePickerToolbar-root {
    background-color: #d2112b !important;
    color: white !important;
}

.css-1o36b95-MuiTypography-root-MuiPickersToolbarText-root {
    color: #fff;
}

.MuiPickersToolbar-content .css-15jcv2p-MuiPickersToolbar-content,
.css-14cinwp-MuiTypography-root-MuiPickersToolbarText-root,
.css-1ljf62l-MuiTypography-root-MuiPickersToolbarText-root-MuiDateTimePickerToolbar-separator,
.css-lp81p6-MuiTypography-root-MuiPickersToolbarText-root,
.css-1o36b95-MuiTypography-root-MuiPickersToolbarText-root.Mui-selected {
    color: #fff !important;
}

.css-1i5jzbk-MuiTabs-indicator {
    background-color: #d2112b !important;
}

.css-jh0g7c-MuiButtonBase-root-MuiTab-root.Mui-selected {
    color: #d2112b !important;
}
/* mobile date time picker style */

/* modal background */
.makeStyles-modal_background-49 {
    background-color: #d2112b !important;
}
/* modal background */

.search-box {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 5;
    width: 300px;
    border-radius: 3px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
    padding: 10px;
    display: flex;
    align-items: center;
}

.search-input {
    width: 100%;
    padding: 8px;
    border: none;
    border-radius: 3px;
    box-sizing: border-box;
    font-size: 16px;
    outline: none;
}

.blue-background {
    background: #ffffff !important;
    border: 1px solid #d2112b !important;
    /* background: #d2112b !important; */
    border-radius: 5px 5px 5px 5px;
    -webkit-border-radius: 5px 5px 5px 5px;
    -moz-border-radius: 5px 5px 5px 5px;
    -ms-border-radius: 5px 5px 5px 5px;
    -o-border-radius: 5px 5px 5px 5px;
    height: 50px !important;
}

.MuiGrid-root.countryFlag.MuiGrid-item.MuiGrid-grid-md-1 {
    display: flex !important;
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    align-content: center !important;
    justify-content: flex-start !important;
    align-items: center !important;
}

.MuiGrid-root.countryFlag.MuiGrid-item.MuiGrid-grid-md-1 p {
    text-align: center !important;
    font-weight: 500 !important;
    font-size: small !important;
}

.blue-background > .MuiCardHeader-content > span {
    color: #d2112b !important;
    font-family: 'BebasNeue-Bold' !important;
    text-transform: uppercase !important;
    font-size: 32px !important;
    white-space: nowrap;
}

.blue-background > .MuiCardHeader-content > span {
    color: #d2112b !important;
    font-family: 'BebasNeue-Bold' !important;
    text-transform: uppercase !important;
    font-size: 32px !important;
}

.red-background {
    background: #d2112b !important;
    border-radius: 5px 5px 0 0;
    -webkit-border-radius: 5px 5px 0 0;
    -moz-border-radius: 5px 5px 0 0;
    -ms-border-radius: 5px 5px 0 0;
    -o-border-radius: 5px 5px 0 0;
    height: 50px !important;
}

.red-background > .MuiCardHeader-content > span {
    color: white !important;
    font-family: 'BebasNeue-Bold' !important;
    text-transform: uppercase !important;
    font-size: 32px !important;
    white-space: nowrap;
}

.red-background > .MuiCardHeader-content > span {
    color: white !important;
    font-family: 'BebasNeue-Bold' !important;
    text-transform: uppercase !important;
    font-size: 32px !important;
}

@media screen and (max-width: 425px) {
    .red-background > .MuiCardHeader-content > span {
        font-size: 24px !important;
    }
}

.padding-con {
    padding-right: 25px !important;
    padding-left: 25px !important;
    padding-top: 25px !important;
    padding-bottom: 25px !important;
}

.searchbyCustomer .MuiFormControlLabel-root {
    /* cursor: pointer; */
    display: inline-flex;
    align-items: center;
    margin-left: -3px;
    margin-right: 2px !important;
    vertical-align: middle;
    -webkit-tap-highlight-color: transparent;
    margin-bottom: 0px;
}

.olo_orders_font {
    font-family: 'Open Sans';
}

.css-t3ycia-MuiChip-label {
    font-family: 'Open Sans';
    font-weight: 600;
    color: #181818;
}

.res-container-min {
    padding: 6px 14px;
}

.searchbyCustomer span.field_label_txt {
    font-family: 'Open Sans';
    font-size: 16px !important;
    font-weight: 700;
    line-height: normal;
    letter-spacing: normal;
    background: transparent;
    color: #181818;
    padding-top: 6px;
    padding-left: 0px !important;
    padding-right: 10px !important;
    text-transform: capitalize;
}

.file_upload {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: white;
    color: #d2112b;
    border: 1px solid #d2112b !important;
    border-color: #d2112b !important;
    transition: 1s !important;
    font-family: 'BebasNeue-Bold';
    font-weight: 900;
    letter-spacing: '1px';
    font-size: '18px';
    text-transform: 'uppercase';
    gap: 12px;

    color: #d2112b;
    padding: 8px 32px;
    border-radius: 4px;
    width: 120px;
    cursor: pointer;
    text-align: center;
}

.file_upload:hover {
    background: #d2112b;
    color: white;
    border-color: red !important;
    transition: 1s !important;
    box-shadow: '4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)';
}

.mainheadingsales {
    position: absolute;
    top: -15;
    background-color: #fff !important;
    padding: 0px 10px 0px 9px;
    font-size: 14px;
    color: black;
    font-weight: bolder;
    font-family: 'BebasNeue-thin';
    letter-spacing: 1px;
}

.copy_icon {
    color: #d2112b !important;
    background: rgb(255 255 255) !important;
    font-size: 24px !important;
}

.field_label_txt-left {
    font-family: 'BebasNeue-Book';
    font-weight: 600;
    font-size: 13px;
    color: #666666 !important;
    text-align: left;
    line-height: 1.5;
}

.css-19kzrtu {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
    padding-top: 10px !important;
}

.tab_classes_padding {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-bottom: 0px !important;
    padding-top: 0px !important;
}

.edit-switch span {
    font-family: 'BebasNeue-Bold';
    font-size: 19px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: white !important;
}

.edit-switch-map span {
    font-family: 'BebasNeue-Bold';
    font-size: 19px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #d2112b !important;
}

.css-5ozfyl-MuiSwitch-root .Mui-checked .MuiSwitch-thumb {
    background: white !important;
}

.MuiInputBase-adornedStart {
    padding: 0px;
}

input#arithmetic_condition_txt {
    width: 10px !important;
}

.no-records-found {
    font-family: 'BebasNeue-Bold';
}

#input_label_style {
    font-family: 'BebasNeue-Book';
}

.error_402 {
    color: #d2112b;
    font-size: 100px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    font-family: 'BebasNeue-Bold';
    text-transform: uppercase;
    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
}

span.MuiTimelineDot-root {
    background-color: #d2112b;
    border-width: 1px;
    padding: 2px;
}

button#active_button {
    color: #d2112b !important;
}

.no-records-found {
    font-size: 22px !important;
    width: 100% !important;
    text-align: center;
    text-transform: uppercase;
}

.list-item {
    background-color: white !important;
    color: #d2112b !important;
    align-items: center;
}

.list-item:hover {
    background-color: rgba(94, 94, 94, 0.116) !important;
}

.active-list-item {
    background-color: #d2112b !important;
    color: white !important;
    align-items: center;
}

.css-1db5i3l-MuiFormControl-root-MuiTextField-root {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
}

.MuiCardHeader-action {
    margin-top: -20px;
}

.container-heading-text > .MuiCardHeader-content > span {
    font-family: 'BebasNeue-Bold' !important;
    text-transform: uppercase;
    font-size: 25px;
    color: #d2112b;
    padding: 0px 0px 10px 0px !important;
}

.black_heading {
    font-family: 'BebasNeue-Bold' !important;
    text-transform: uppercase;
    font-size: 25px;
    color: #000;
}

.header-icon-align {
    font-size: 25px !important;
    color: #d2112b !important;
    margin-top: 15px;
}

.field_label_txt {
    /* padding: 0px 0px 4px 10px; */
    font-family: 'Open Sans';
    font-size: 15px;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 1px;
    color: #181818;
    text-transform: capitalize;
}

.field_label_txt_with {
    padding: 0px 0px 4px 10px;
    font-family: 'BebasNeue-Book';
    font-size: 16;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 1px;
    color: #000;
}

.price-text-strike {
    text-decoration: line-through;
    font-weight: 500;
}

.layout_sub_heading_txt {
    font-size: 26px;
    color: white;
    padding-right: 10px;
    margin-block-start: 0em !important;
    margin-block-end: 0em !important;
    text-align: left;
    text-transform: uppercase;
    font-family: 'BebasNeue-Bold' !important;
}

.orderDetailPanel {
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
    font-family: 'Open Sans';
    color: #181818;
    /* text-transform: uppercase !important; */
}

.orderDetailPanel5 {
    font-size: 13px !important;
    line-height: 1.5 !important;
    text-transform: capitalize !important;
    margin-bottom: 0px !important;
}

.orderDetailPanel3 {
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
    text-transform: uppercase !important;
    margin-top: 5 !important;
}

.css-ufwick-MuiButtonBase-root-MuiPickersDay-root.Mui-selected {
    background-color: #d2112b !important;
}

.zoom {
    transition: transform 0.2s;
    /*Animation*/
    object-fit: contain;
    -webkit-transition: transform 0.2s;
    -moz-transition: transform 0.2s;
    -ms-transition: transform 0.2s;
    -o-transition: transform 0.2s;
}
.zoom:hover {
    transform: scale(1.5);
    /*(150%zoom-Note: if the zoom is too large, it will go outside of the viewport) */
    -webkit-transform: scale(1.5);
    -moz-transform: scale(1.5);
    -ms-transform: scale(1.5);
    -o-transform: scale(1.5);
}

.css-ukiac-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator {
    margin-right: -10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,4CAAgD;AACpD;;AAEA;IACI,0BAA0B;IAC1B,4CAA+C;AACnD;;AAEA;IACI,mCAAmC;IACnC,4CAAwD;AAC5D;;AAEA;IACI,oCAAoC;IACpC,4CAAyD;AAC7D;;AAEA;IACI,sCAAsC;IACtC,4CAA2D;AAC/D;;AAEA;IACI,uCAAuC;IACvC,4CAA4D;AAChE;;AAEA;IACI,4BAA4B;IAC5B,4CAAiD;AACrD;;AAEA;IACI,4BAA4B;IAC5B,4CAAiD;AACrD;;AAEA;IACI,6BAA6B;IAC7B,4CAAkD;AACtD;;AAEA;IACI,6BAA6B;IAC7B,4CAAqD;AACzD;;AAEA;IACI,6BAA6B;IAC7B,6CAAqD;AACzD;;AAEA;IACI,6BAA6B;IAC7B,6CAAqD;AACzD;;AAEA;IACI,8BAA8B;IAC9B,6CAAsD;AAC1D;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;uBACmB;AACvB;;AAEA,aAAa;AACb;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;uBACmB;AACvB;;AAEA,cAAc;AACd;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;uBACmB;AACvB;;AAEA,UAAU;AACV;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;uBACmB;AACvB;;AAEA,eAAe;AACf;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;uBACmB;AACvB;;AAEA,cAAc;AACd;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;uBACmB;AACvB;;AAEA,UAAU;AACV;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;uBACmB;AACvB;;AAEA,uBAAuB;;AAEvB;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;;;;;GAKG;;AAEH;IACI;;;sDAGkD;AACtD;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,yBAAyB;QACzB,oBAAoB;QACpB,iBAAiB;IACrB;IACA;QACI,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,oCAAoC;QACpC,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;IACtC,cAAc;IACd,kCAAkC;IAClC,OAAO;IACP,UAAU;IACV,MAAM;IACN,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;;;;IAII,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;;;QAGI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;;QAEI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,oCAAoC;QACpC,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;;;;;;;IAOI,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,cAAc;EAChB;AACF;IACI,wBAAwB;AAC5B;AACA;IACI,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;AACpC;;AAEA,0BAA0B;;AAE1B;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI;QACI,8BAA8B;IAClC;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,sCAAsC;IAC1C;IACA;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,oCAAoC;QACpC,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,oCAAoC;QACpC,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,oCAAoC;QACpC,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;;;;;;;IASI,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;IAKI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;AACA,kCAAkC;;AAElC,qBAAqB;AACrB;IACI,oCAAoC;AACxC;AACA,qBAAqB;;AAErB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,oCAAoC;IACpC,8BAA8B;IAC9B,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;IAClC,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,gCAAgC;IAChC,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,oCAAoC;IACpC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,oCAAoC;IACpC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,cAAc;IACd,oCAAoC;IACpC,gCAAgC;IAChC,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;;IAET,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;IACzB,kHAAkH;AACtH;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,iCAAiC;IACjC,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,6BAA6B;IAC7B,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,gCAAgC;IAChC,gBAAgB;IAChB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,qCAAqC;IACrC,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;AACjC;AACA;IACI,qBAAqB;IACrB,iFAAiF;IACjF,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["@font-face {\n    font-family: 'Roboto-Black';\n    src: url('assets/fonts/Roboto/Roboto-Black.ttf');\n}\n\n@font-face {\n    font-family: 'Roboto-Bold';\n    src: url('assets/fonts/Roboto/Roboto-Bold.ttf');\n}\n\n@font-face {\n    font-family: 'Roboto-Medium-Italic';\n    src: url('assets/fonts/Roboto/Roboto-Medium-Italic.ttf');\n}\n\n@font-face {\n    font-family: 'Roboto-Condensed-Bold';\n    src: url('assets/fonts/Roboto/Roboto-Condensed-Bold.ttf');\n}\n\n@font-face {\n    font-family: 'Roboto-Condensed-Medium';\n    src: url('assets/fonts/Roboto/Roboto-Condensed-Medium.ttf');\n}\n\n@font-face {\n    font-family: 'Roboto-Condensed-Regular';\n    src: url('assets/fonts/Roboto/Roboto-Condensed-Regular.ttf');\n}\n\n@font-face {\n    font-family: 'Roboto-Italic';\n    src: url('assets/fonts/Roboto/Roboto-Italic.ttf');\n}\n\n@font-face {\n    font-family: 'Roboto-Medium';\n    src: url('assets/fonts/Roboto/Roboto-Medium.ttf');\n}\n\n@font-face {\n    font-family: 'Roboto-Regular';\n    src: url('assets/fonts/Roboto/Roboto-Regular.ttf');\n}\n\n@font-face {\n    font-family: 'BebasNeue-Bold';\n    src: url('assets/fonts/BebasNeue/BebasNeue-Bold.otf');\n}\n\n@font-face {\n    font-family: 'BebasNeue-Book';\n    src: url('assets/fonts/BebasNeue/BebasNeue-Book.otf');\n}\n\n@font-face {\n    font-family: 'BebasNeue-Thin';\n    src: url('assets/fonts/BebasNeue/BebasNeue-Thin.otf');\n}\n\n@font-face {\n    font-family: 'BebasNeue-Light';\n    src: url('assets/fonts/BebasNeue/BebasNeue-Light.otf');\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: normal;\n    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFWJ0bbck.woff2)\n        format('woff2');\n}\n\n/* cyrillic */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: normal;\n    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFUZ0bbck.woff2)\n        format('woff2');\n}\n\n/* greek-ext */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: normal;\n    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFWZ0bbck.woff2)\n        format('woff2');\n}\n\n/* greek */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: normal;\n    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFVp0bbck.woff2)\n        format('woff2');\n}\n\n/* vietnamese */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: normal;\n    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFWp0bbck.woff2)\n        format('woff2');\n}\n\n/* latin-ext */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: normal;\n    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFW50bbck.woff2)\n        format('woff2');\n}\n\n/* latin */\n@font-face {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: normal;\n    src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFVZ0b.woff2)\n        format('woff2');\n}\n\n/* LOADING TRANSITION */\n\n.table-cell-nowrap {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.search-filters-box {\n    border: 1px solid lightgray;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 2px 0px 0px 0px;\n    position: relative;\n    margin-right: 5px;\n}\n\n.search-filter-buttons {\n    display: flex;\n    justify-content: flex-end;\n    /* padding-bottom: 20px; */\n    padding-top: 20px;\n}\n\n/* .css-a2j6v-MuiPaper-root {\n    box-shadow:\n        rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,\n        rgba(0, 0, 0, 0.14) 0px 2px 2px 0px,\n        rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;\n} */\n\n.paper-box-shadow-specific {\n    box-shadow:\n        rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,\n        rgba(0, 0, 0, 0.14) 0px 2px 2px 0px,\n        rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;\n}\n\n@media screen and (max-width: 635px) {\n    .search-filter-buttons {\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        padding-bottom: 20px;\n        padding-top: 20px;\n    }\n    .search-filter-buttons button {\n        margin-right: 0px !important;\n        margin-bottom: 10px;\n    }\n\n    .active-list-item {\n        background-color: #d2112b !important;\n        color: white !important;\n        align-items: center;\n        padding-left: 10px;\n    }\n}\n\n.ctn-preloader {\n    align-items: center;\n    -webkit-align-items: center;\n    display: flex;\n    display: -ms-flexbox;\n    height: 100%;\n    justify-content: center;\n    -webkit-justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    z-index: 999999;\n    background: #000000bd;\n}\n\n.ctn-preloader .animation-preloader {\n    position: absolute;\n    z-index: 100;\n    text-align: center;\n}\n\n.ctn-preloader .animation-preloader .icon {\n    display: inline-block;\n    position: relative;\n}\n\n.ctn-preloader .animation-preloader .txt-loading {\n    user-select: none;\n}\n\n.ctn-preloader .animation-preloader .txt-loading .letters-loading:before {\n    animation: letters-loading 4s infinite;\n    color: #d2112b;\n    content: attr(data-text-preloader);\n    left: 0;\n    opacity: 0;\n    top: 0;\n    line-height: 30px;\n    position: absolute;\n}\n\n.ctn-preloader .animation-preloader .txt-loading .letters-loading {\n    font-family: 'Roboto-Regular';\n    letter-spacing: 12px;\n    display: inline-block;\n    color: #d2112c;\n    position: relative;\n    font-size: 50px;\n    line-height: 30px;\n}\n\n.ctn-preloader\n    .animation-preloader\n    .txt-loading\n    .letters-loading:nth-child(2):before {\n    animation-delay: 0.2s;\n}\n\n.ctn-preloader\n    .animation-preloader\n    .txt-loading\n    .letters-loading:nth-child(3):before {\n    animation-delay: 0.4s;\n}\n\n.ctn-preloader\n    .animation-preloader\n    .txt-loading\n    .letters-loading:nth-child(4):before {\n    animation-delay: 0.6s;\n}\n\n.ctn-preloader\n    .animation-preloader\n    .txt-loading\n    .letters-loading:nth-child(5):before {\n    animation-delay: 0.8s;\n}\n\n.ctn-preloader\n    .animation-preloader\n    .txt-loading\n    .letters-loading:nth-child(6):before {\n    animation-delay: 1s;\n}\n\n.ctn-preloader\n    .animation-preloader\n    .txt-loading\n    .letters-loading:nth-child(7):before {\n    animation-delay: 1.2s;\n}\n\n.ctn-preloader\n    .animation-preloader\n    .txt-loading\n    .letters-loading:nth-child(8):before {\n    animation-delay: 1.4s;\n}\n\n.loaded .animation-preloader {\n    opacity: 0;\n    transition: 0.3s ease-out;\n}\n\n@keyframes spinner {\n    to {\n        transform: rotateZ(360deg);\n    }\n}\n\n@keyframes letters-loading {\n    0%,\n    75%,\n    100% {\n        opacity: 0;\n        transform: rotateY(-90deg);\n    }\n\n    25%,\n    50% {\n        opacity: 1;\n        transform: rotateY(0deg);\n    }\n}\n\n@media screen and (max-width: 500px) {\n    .ctn-preloader .animation-preloader .txt-loading .letters-loading {\n        font-size: 40px;\n        letter-spacing: 10px;\n    }\n\n    .active-list-item {\n        background-color: #d2112b !important;\n        color: white !important;\n        align-items: center;\n        padding-left: 10px;\n    }\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 0px !important;\n}\n\n.Roboto-Black {\n    font-family: 'Roboto-Black' !important;\n}\n\n.Roboto-Bold {\n    font-family: 'Roboto-Bold' !important;\n}\n\n.Roboto-Condensed-Bold {\n    font-family: 'Roboto-Condensed-Bold' !important;\n}\n\n.Roboto-Condensed-Medium {\n    font-family: 'Roboto-Condensed-Medium' !important;\n}\n\n.Roboto-Condensed-Regular {\n    font-family: 'Roboto-Condensed-Regular' !important;\n}\n\n.Roboto-Italic {\n    font-family: 'Roboto-Italic' !important;\n}\n\n.Roboto-Medium {\n    font-family: 'Roboto-Medium' !important;\n}\n\n.Roboto-Regular {\n    font-family: 'Roboto-Regular' !important;\n}\n\n.Roboto-Medium-Italic {\n    font-family: 'Roboto-Medium-Italic' !important;\n}\n\n.BebasNeue-Light {\n    font-family: 'BebasNeue-Book' !important;\n}\n\n.BebasNeue {\n    font-family: 'BebasNeue-Bold' !important;\n}\n\n.side-bar-scroll {\n    height: 100%;\n    overflow: auto;\n  }\n.side-bar-scroll::-webkit-scrollbar {\n    display: none !important;\n}\n.side-bar-scroll::-webkit-scrollbar-track {\n    background: #d2112c;\n    width: 0px;\n}\n.side-bar-scroll::-webkit-scrollbar-thumb {\n    background: #d2112c;\n    border-radius: 5px !important;\n    cursor: pointer;\n}\n\n.body::-webkit-scrollbar {\n    width: 7px;\n}\n\nbody::-webkit-scrollbar-track {\n    background: #d2112b;\n}\n\nbody::-webkit-scrollbar-thumb {\n    background: #d2112b;\n    border-radius: 0;\n}\n\n*::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    border-radius: 100;\n}\n\n*::-webkit-scrollbar-track {\n    background: white;\n}\n\n*::-webkit-scrollbar-thumb {\n    background: lightgray;\n    border-radius: 100;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.padding-0 {\n    padding: 0px;\n}\n\n.padding-5 {\n    padding: 5px;\n}\n\n.padding-10 {\n    padding: 10px;\n}\n\n.padding-20 {\n    padding: 20px;\n}\n\n.selected-row {\n    border-top: 1px solid red;\n    border-bottom: 1px solid red;\n}\n\n.unselected-row {\n    border-top: 1px solid transparent;\n    border-bottom: 1px solid transparent;\n}\n\ntd {\n    border-bottom: none !important;\n}\n\n.text_feild_small {\n    height: 36px !important;\n}\n\n.disabled-bg {\n    background-color: #efefef !important;\n}\n\n.ps__rail-y {\n    display: none !important;\n}\n\n.border-bottom-black {\n    border-bottom: 1px solid #3e3e3e;\n}\n\n/* Material Autocomplete */\n\n.MuiAutocomplete-tag {\n    background: #fff;\n    color: black;\n    border-radius: 5px;\n    font-family: Roboto-Medium;\n    font-size: 16px;\n    font-weight: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    background: transparent;\n    color: rgb(0, 0, 0);\n}\n\n.css-ue4sux-MuiPickersToolbar-root-MuiDatePickerToolbar-root {\n    background-color: #d2112b !important;\n    color: #d2112b !important;\n}\n\n.css-7bgu36-MuiButtonBase-root-MuiPickersDay-root.Mui-selected {\n    background-color: #d2112b !important;\n}\n.css-7bgu36-MuiButtonBase-root-MuiPickersDay-root.Mui-selected:hover {\n    background-color: #d2112b !important;\n}\n\n.css-1azxcoc-MuiButtonBase-root-MuiButton-root {\n    color: #d2112b !important;\n}\n\n.MuiDatePickerToolbar-title {\n    color: white !important;\n}\n\n.css-1b0xoj9-MuiPickersYear-yearButton.Mui-selected {\n    background-color: #d2112b !important;\n}\n\n.mobile-container-input:focus + .mobile-container {\n    border: 1px solid #d2112b !important;\n}\n\n.mobile-container:hover {\n    border: 1px solid #d2112b !important;\n}\n.breadcrumb_time {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n#panel1a-header {\n    background-color: #d2112b;\n    color: #fff;\n}\n\n#panel1a-header > div.MuiAccordionSummary-content,\n.MuiAccordionSummary-root {\n    min-height: 30px !important;\n    max-height: 54px !important;\n}\n\n@media screen and (max-width: 425px) {\n    .table-scrollbar {\n        height: max-content !important;\n    }\n    .breadcrumb_time {\n        display: flex;\n        align-items: center !important;\n        justify-content: flex-start !important;\n    }\n    .css-k3ndhj {\n        margin-left: 0px;\n        width: 100%;\n    }\n    .active-list-item {\n        background-color: #d2112b !important;\n        color: white !important;\n        align-items: center;\n        padding-left: 10px;\n    }\n    .list-item {\n        background-color: #d2112b !important;\n        color: white !important;\n        align-items: center;\n        padding-left: 10px;\n    }\n}\n\n@media screen and (max-width: 360px) {\n    .active-list-item {\n        background-color: #d2112b !important;\n        color: white !important;\n        align-items: center;\n        padding-right: 10px;\n    }\n}\n\n.static-col-width {\n    width: 200px !important;\n    max-width: 200px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.width-33 {\n    width: 33px !important;\n    max-width: 33px !important;\n}\n\n.css-g60yx6-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {\n    background: #fff !important;\n}\n\n.css-e0n9jt-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {\n    background: #fff !important;\n}\n\n.css-1pj14c4-MuiInputBase-root-MuiOutlinedInput-root {\n    background: #fff !important;\n}\n\n.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n    border-color: #d2112b !important;\n}\n\n.css-1x7p6i5-MuiInputBase-input-MuiOutlinedInput-input:focus\n    + .MuiOutlinedInput-notchedOutline {\n    border-color: #d2112b !important;\n}\n\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: #d2112b !important;\n}\n\n.css-1h582ii-MuiPickersToolbar-root-MuiTimePickerToolbar-root,\n.css-9140k-MuiTypography-root-MuiPickersToolbarText-root,\n.css-ihhycx-MuiTimePickerToolbar-amPmSelection .MuiTimePickerToolbar-ampmLabel,\n.css-mm61pc-MuiTypography-root-MuiPickersToolbarText-root-MuiTimePickerToolbar-separator,\n.css-1w4nrh4-MuiClockPointer-thumb,\n.css-ff5riy-MuiClock-pin,\n.css-1egoljz-MuiClockPointer-root,\n.css-338pcd-MuiClockPointer-root,\n.css-uhmbur-MuiClockPointer-thumb {\n    background-color: #d2112b !important;\n    border-color: #d2112b !important;\n    color: #fff !important;\n}\n\n.css-rixs2p {\n    background-color: #d2112b !important;\n    color: #d2112b !important;\n}\n\n/* mobile date time picker style */\n.css-s9q20a-MuiPickersToolbar-root-MuiDateTimePickerToolbar-root {\n    background-color: #d2112b !important;\n    color: white !important;\n}\n\n.css-1o36b95-MuiTypography-root-MuiPickersToolbarText-root {\n    color: #fff;\n}\n\n.MuiPickersToolbar-content .css-15jcv2p-MuiPickersToolbar-content,\n.css-14cinwp-MuiTypography-root-MuiPickersToolbarText-root,\n.css-1ljf62l-MuiTypography-root-MuiPickersToolbarText-root-MuiDateTimePickerToolbar-separator,\n.css-lp81p6-MuiTypography-root-MuiPickersToolbarText-root,\n.css-1o36b95-MuiTypography-root-MuiPickersToolbarText-root.Mui-selected {\n    color: #fff !important;\n}\n\n.css-1i5jzbk-MuiTabs-indicator {\n    background-color: #d2112b !important;\n}\n\n.css-jh0g7c-MuiButtonBase-root-MuiTab-root.Mui-selected {\n    color: #d2112b !important;\n}\n/* mobile date time picker style */\n\n/* modal background */\n.makeStyles-modal_background-49 {\n    background-color: #d2112b !important;\n}\n/* modal background */\n\n.search-box {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 5;\n    width: 300px;\n    border-radius: 3px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n    background-color: #fff;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n}\n\n.search-input {\n    width: 100%;\n    padding: 8px;\n    border: none;\n    border-radius: 3px;\n    box-sizing: border-box;\n    font-size: 16px;\n    outline: none;\n}\n\n.blue-background {\n    background: #ffffff !important;\n    border: 1px solid #d2112b !important;\n    /* background: #d2112b !important; */\n    border-radius: 5px 5px 5px 5px;\n    -webkit-border-radius: 5px 5px 5px 5px;\n    -moz-border-radius: 5px 5px 5px 5px;\n    -ms-border-radius: 5px 5px 5px 5px;\n    -o-border-radius: 5px 5px 5px 5px;\n    height: 50px !important;\n}\n\n.MuiGrid-root.countryFlag.MuiGrid-item.MuiGrid-grid-md-1 {\n    display: flex !important;\n    flex-direction: column !important;\n    flex-wrap: nowrap !important;\n    align-content: center !important;\n    justify-content: flex-start !important;\n    align-items: center !important;\n}\n\n.MuiGrid-root.countryFlag.MuiGrid-item.MuiGrid-grid-md-1 p {\n    text-align: center !important;\n    font-weight: 500 !important;\n    font-size: small !important;\n}\n\n.blue-background > .MuiCardHeader-content > span {\n    color: #d2112b !important;\n    font-family: 'BebasNeue-Bold' !important;\n    text-transform: uppercase !important;\n    font-size: 32px !important;\n    white-space: nowrap;\n}\n\n.blue-background > .MuiCardHeader-content > span {\n    color: #d2112b !important;\n    font-family: 'BebasNeue-Bold' !important;\n    text-transform: uppercase !important;\n    font-size: 32px !important;\n}\n\n.red-background {\n    background: #d2112b !important;\n    border-radius: 5px 5px 0 0;\n    -webkit-border-radius: 5px 5px 0 0;\n    -moz-border-radius: 5px 5px 0 0;\n    -ms-border-radius: 5px 5px 0 0;\n    -o-border-radius: 5px 5px 0 0;\n    height: 50px !important;\n}\n\n.red-background > .MuiCardHeader-content > span {\n    color: white !important;\n    font-family: 'BebasNeue-Bold' !important;\n    text-transform: uppercase !important;\n    font-size: 32px !important;\n    white-space: nowrap;\n}\n\n.red-background > .MuiCardHeader-content > span {\n    color: white !important;\n    font-family: 'BebasNeue-Bold' !important;\n    text-transform: uppercase !important;\n    font-size: 32px !important;\n}\n\n@media screen and (max-width: 425px) {\n    .red-background > .MuiCardHeader-content > span {\n        font-size: 24px !important;\n    }\n}\n\n.padding-con {\n    padding-right: 25px !important;\n    padding-left: 25px !important;\n    padding-top: 25px !important;\n    padding-bottom: 25px !important;\n}\n\n.searchbyCustomer .MuiFormControlLabel-root {\n    /* cursor: pointer; */\n    display: inline-flex;\n    align-items: center;\n    margin-left: -3px;\n    margin-right: 2px !important;\n    vertical-align: middle;\n    -webkit-tap-highlight-color: transparent;\n    margin-bottom: 0px;\n}\n\n.olo_orders_font {\n    font-family: 'Open Sans';\n}\n\n.css-t3ycia-MuiChip-label {\n    font-family: 'Open Sans';\n    font-weight: 600;\n    color: #181818;\n}\n\n.res-container-min {\n    padding: 6px 14px;\n}\n\n.searchbyCustomer span.field_label_txt {\n    font-family: 'Open Sans';\n    font-size: 16px !important;\n    font-weight: 700;\n    line-height: normal;\n    letter-spacing: normal;\n    background: transparent;\n    color: #181818;\n    padding-top: 6px;\n    padding-left: 0px !important;\n    padding-right: 10px !important;\n    text-transform: capitalize;\n}\n\n.file_upload {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    background: white;\n    color: #d2112b;\n    border: 1px solid #d2112b !important;\n    border-color: #d2112b !important;\n    transition: 1s !important;\n    font-family: 'BebasNeue-Bold';\n    font-weight: 900;\n    letter-spacing: '1px';\n    font-size: '18px';\n    text-transform: 'uppercase';\n    gap: 12px;\n\n    color: #d2112b;\n    padding: 8px 32px;\n    border-radius: 4px;\n    width: 120px;\n    cursor: pointer;\n    text-align: center;\n}\n\n.file_upload:hover {\n    background: #d2112b;\n    color: white;\n    border-color: red !important;\n    transition: 1s !important;\n    box-shadow: '4px 4px 3px -1px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)';\n}\n\n.mainheadingsales {\n    position: absolute;\n    top: -15;\n    background-color: #fff !important;\n    padding: 0px 10px 0px 9px;\n    font-size: 14px;\n    color: black;\n    font-weight: bolder;\n    font-family: 'BebasNeue-thin';\n    letter-spacing: 1px;\n}\n\n.copy_icon {\n    color: #d2112b !important;\n    background: rgb(255 255 255) !important;\n    font-size: 24px !important;\n}\n\n.field_label_txt-left {\n    font-family: 'BebasNeue-Book';\n    font-weight: 600;\n    font-size: 13px;\n    color: #666666 !important;\n    text-align: left;\n    line-height: 1.5;\n}\n\n.css-19kzrtu {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n    padding-bottom: 0px !important;\n    padding-top: 10px !important;\n}\n\n.tab_classes_padding {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n}\n\n.edit-switch span {\n    font-family: 'BebasNeue-Bold';\n    font-size: 19px;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    color: white !important;\n}\n\n.edit-switch-map span {\n    font-family: 'BebasNeue-Bold';\n    font-size: 19px;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    color: #d2112b !important;\n}\n\n.css-5ozfyl-MuiSwitch-root .Mui-checked .MuiSwitch-thumb {\n    background: white !important;\n}\n\n.MuiInputBase-adornedStart {\n    padding: 0px;\n}\n\ninput#arithmetic_condition_txt {\n    width: 10px !important;\n}\n\n.no-records-found {\n    font-family: 'BebasNeue-Bold';\n}\n\n#input_label_style {\n    font-family: 'BebasNeue-Book';\n}\n\n.error_402 {\n    color: #d2112b;\n    font-size: 100px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    font-family: 'BebasNeue-Bold';\n    text-transform: uppercase;\n    filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));\n}\n\nspan.MuiTimelineDot-root {\n    background-color: #d2112b;\n    border-width: 1px;\n    padding: 2px;\n}\n\nbutton#active_button {\n    color: #d2112b !important;\n}\n\n.no-records-found {\n    font-size: 22px !important;\n    width: 100% !important;\n    text-align: center;\n    text-transform: uppercase;\n}\n\n.list-item {\n    background-color: white !important;\n    color: #d2112b !important;\n    align-items: center;\n}\n\n.list-item:hover {\n    background-color: rgba(94, 94, 94, 0.116) !important;\n}\n\n.active-list-item {\n    background-color: #d2112b !important;\n    color: white !important;\n    align-items: center;\n}\n\n.css-1db5i3l-MuiFormControl-root-MuiTextField-root {\n    outline: none !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\n.MuiCardHeader-action {\n    margin-top: -20px;\n}\n\n.container-heading-text > .MuiCardHeader-content > span {\n    font-family: 'BebasNeue-Bold' !important;\n    text-transform: uppercase;\n    font-size: 25px;\n    color: #d2112b;\n    padding: 0px 0px 10px 0px !important;\n}\n\n.black_heading {\n    font-family: 'BebasNeue-Bold' !important;\n    text-transform: uppercase;\n    font-size: 25px;\n    color: #000;\n}\n\n.header-icon-align {\n    font-size: 25px !important;\n    color: #d2112b !important;\n    margin-top: 15px;\n}\n\n.field_label_txt {\n    /* padding: 0px 0px 4px 10px; */\n    font-family: 'Open Sans';\n    font-size: 15px;\n    font-weight: 900;\n    line-height: normal;\n    letter-spacing: 1px;\n    color: #181818;\n    text-transform: capitalize;\n}\n\n.field_label_txt_with {\n    padding: 0px 0px 4px 10px;\n    font-family: 'BebasNeue-Book';\n    font-size: 16;\n    font-weight: 900;\n    line-height: normal;\n    letter-spacing: 1px;\n    color: #000;\n}\n\n.price-text-strike {\n    text-decoration: line-through;\n    font-weight: 500;\n}\n\n.layout_sub_heading_txt {\n    font-size: 26px;\n    color: white;\n    padding-right: 10px;\n    margin-block-start: 0em !important;\n    margin-block-end: 0em !important;\n    text-align: left;\n    text-transform: uppercase;\n    font-family: 'BebasNeue-Bold' !important;\n}\n\n.orderDetailPanel {\n    font-weight: 600 !important;\n    font-size: 14px !important;\n    line-height: 1.5 !important;\n    font-family: 'Open Sans';\n    color: #181818;\n    /* text-transform: uppercase !important; */\n}\n\n.orderDetailPanel5 {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    text-transform: capitalize !important;\n    margin-bottom: 0px !important;\n}\n\n.orderDetailPanel3 {\n    font-weight: 600 !important;\n    font-size: 14px !important;\n    line-height: 1.5 !important;\n    text-transform: uppercase !important;\n    margin-top: 5 !important;\n}\n\n.css-ufwick-MuiButtonBase-root-MuiPickersDay-root.Mui-selected {\n    background-color: #d2112b !important;\n}\n\n.zoom {\n    transition: transform 0.2s;\n    /*Animation*/\n    object-fit: contain;\n    -webkit-transition: transform 0.2s;\n    -moz-transition: transform 0.2s;\n    -ms-transition: transform 0.2s;\n    -o-transition: transform 0.2s;\n}\n.zoom:hover {\n    transform: scale(1.5);\n    /*(150%zoom-Note: if the zoom is too large, it will go outside of the viewport) */\n    -webkit-transform: scale(1.5);\n    -moz-transform: scale(1.5);\n    -ms-transform: scale(1.5);\n    -o-transform: scale(1.5);\n}\n\n.css-ukiac-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator {\n    margin-right: -10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
